<template>
	<div class="ssp">
		<div class="ssp__container container">
			<div class="ssp__wrapper">
				<div class="ssp__img-wrapper">
					<NuxtImg
						src="/images/sections/ssp/ssp-img.png"
						alt="SSP"
						class="ssp__img"
						width="440"
						height="440"
						format="webp"
						quality="75"
						loading="lazy"
						decoding="async" />
				</div>
				<div class="ssp__content">
					<h2 class="ssp__content-title heading h2">
						{{ $t('pages.main.sections.ssp.title') }}
					</h2>
					<p class="ssp__content-description">
						{{ $t('pages.main.sections.ssp.description.text1') }}
					</p>
					<p class="ssp__content-description">
						{{ $t('pages.main.sections.ssp.description.text2') }}
					</p>
					<div class="ssp__content-list-wrapper">
						<p class="ssp__content-list-title">
							{{ $t('pages.main.sections.ssp.description.list.title') }}
						</p>
						<ul class="ssp__content-list">
							<li
								v-for="(item, index) in $tm('pages.main.sections.ssp.description.list.items')"
								:key="index"
								class="ssp__content-list-item">
								{{ $rt(item) }}
							</li>
						</ul>
					</div>
					<NuxtLinkLocale to="publishers">
						<button type="button" class="common-btn">
							{{ $t('pages.main.sections.ssp.ctaButton') }}
						</button>
					</NuxtLinkLocale>
				</div>
			</div>
		</div>
		<BlocksPublishersModal v-model:is-modal-open="publisherModal.isOpen" />
	</div>
</template>
<script setup lang="ts">
	const publisherModal = usePublisherModal()
</script>
<style scoped lang="scss">
	.ssp {
		position: relative;
		top: -100px;
		background-color: rgb(29 29 29);
		&__img {
			width: 100%;
			max-height: 440px;
			object-fit: contain;
			&-wrapper {
				position: sticky;
				top: 20px;
				z-index: 0;
				width: 50%;

				@media (width <= 992px) {
					position: absolute;
					top: 0;
					left: -50%;
					width: 100%;
					opacity: 0.4;
				}
			}
		}
		&__wrapper {
			display: flex;
			gap: 48px;
			padding: 64px 0;
			color: var(--white);

			@media (width <= 992px) {
				flex-direction: column;
			}
		}
		&__content {
			position: relative;
			z-index: 1;
			display: flex;
			flex-direction: column;
			gap: 24px;
			&-title {
				text-transform: uppercase;
			}
			&-list {
				padding-left: 1.5em;
				text-indent: -1.5em;
				list-style-type: disc;

				&-title {
					margin-bottom: 8px;
				}
			}
		}
	}
</style>
